export default function StatsBar({ stats }) {
  if (!stats) return null;
  const items = [
    { label: "Total", value: stats.total, color: "#1C1917" },
    { label: "Unclaimed", value: stats.unclaimed, color: "#A8A29E" },
    { label: "Claimed", value: stats.claimed, color: "#EAB308" },
    { label: "Contacted", value: stats.contacted, color: "#4A5D23" },
    { label: "Mine", value: stats.mine, color: "#B85C38" },
  ];
  return (
    <div className="flex items-stretch border border-stone-300 bg-white" data-testid="stats-bar">
      {items.map((it, idx) => (
        <div
          key={it.label}
          className={`px-5 py-3 ${idx > 0 ? "border-l border-stone-300" : ""} min-w-[88px]`}
          data-testid={`stat-${it.label.toLowerCase()}`}
        >
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-stone-500">
            {it.label}
          </div>
          <div className="font-display text-2xl font-bold tracking-tight" style={{ color: it.color }}>
            {it.value}
          </div>
        </div>
      ))}
    </div>
  );
}
